import { logger } from '@tt4b/ttam-utils';
import {
  EffectScope,
  WatchEffect,
  WatchOptionsBase,
  computed,
  effectScope,
  nextTick,
  watchEffect,
} from '@vue/composition-api';

export function scopeFn<P extends any[], T>(fn: (...args: P) => T): (...args: P) => T {
  return function (...args: P) {
    const scope = effectScope(true);
    try {
      return scope.run(() => fn.apply(this, args)) as T;
    } finally {
      scope.stop();
    }
  };
}

function watchEffectWithLoopCheck(effect: WatchEffect, options?: WatchOptionsBase & { onLoop?: () => void }) {
  let runCount = 0;
  let nextTickPromise: Promise<void> | undefined;

  return watchEffect((...args) => {
    if (runCount > 100) {
      options?.onLoop?.();
    }
    if (!nextTickPromise) {
      nextTickPromise = nextTick().finally(() => {
        nextTickPromise = undefined;
        runCount = 0;
      });
    }
    effect(...args);
    runCount++;
  }, options);
}

// 用于消除 computed 调用 computed 带来的内存泄漏
export function scopedComputed<T>(fn: () => T) {
  const result = computed(fn);
  let scope: EffectScope | undefined;
  watchEffectWithLoopCheck(
    () => {
      scope?.stop();
      scope = effectScope(true);
      scope.run(() => {
        result.value;
      });
    },
    {
      flush: 'pre',
      onLoop: () => {
        logger.error('scopedComputed infinite update loop:', fn.toString());
      },
    },
  );
  return result;
}
